import React from 'react'
import { OnlineTemplateManegementStyle } from './styled'
import {
  Button,
  Image,
  Section,
  InputTextarea,
  Input,
  SelectBoxBusinessType,
  Switcher,
  Checkbox,
  AccordionOnlineList,
  Modal,
  Loading,
  InputUpload,
  Loaders,
  AttachedFile,
} from '../../components'

import { ICONS } from '../../themes'
import { map } from 'lodash'
import { businessController, comprehensiveController } from '../../apiService'
import {
  ROUTE_PATH,
  STRING,
  Option,
  ValueContainer,
  MultiValue,
  AnimatedComponents,
  toastFail,
  toastActive,
} from '../../helpers'
import FileDownload from 'js-file-download'
import NumberFormat from 'react-number-format'

export class OnlineTemplateManegementContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      name: '',
      description: '',
      file: '',
      nameSection: '',
      descriptionSection: '',
      weight: '',
      nameValid: false,
      descriptionValid: false,
      disabledSubmit: false,
      formValid: true,
      categoryCompany: [],
      valueCategoryCompany: '',
      isErrorCategoryCompany: false,
      isErrorDuplicate: true,
      isDisableBusinessType: false,

      businessType: [{ valueCategoryCompany: [] }],
      sameBusinessType: [],
      sectionList: [],
      isSubmit: false,
      modalDelete: '',
      sectionIndex: '',
      groupIndex: '',
      questionIndex: '',
      disebleSave: true,
      weightValidate: false,

      onlineByID: '',

      pageTitle: '',
      modal: '',
      isNameDuplicated: false,
      loadingDownloadFile: [],
    }
    // this.renderOptionsCategory = this.renderOptionsCategory.bind(this)
  }

  componentDidMount = async () => {
    this._isMounted = true
    try {
      await this.funcGetBusinessType()
    } catch (error) {
      console.log(error)
    }

    if (this.props.location.state && this.props.location.state.id) {
      this.getOnlineByID(this.props.location.state.id)
      this.setState({ pageTitle: 'Update Template', disebleSave: false })
    } else {
      this.setState({ onlineByID: '' })
      this.setState({ pageTitle: 'Create New Template' })
    }
  }

  async funcGetBusinessType() {
    // const companyId = localStorageService.getCompanyId()
    // const params = {
    //   companyId,
    // }
    // const categories = await usermanageController().getCategories(params)
    const businessType = await businessController().businessType()
    // console.log(businessType)
    if (businessType) {
      const arrBu = map(businessType, (value, index) => {
        const { id, name } = value
        return {
          value: id,
          label: name,
        }
      })
      this.setState({ categoryCompany: arrBu })
    }
  }

  getIdBusinessType(text) {
    const { categoryCompany } = this.state
    let idBusinessType = ''
    categoryCompany.map(item => {
      if (item.label === text) {
        idBusinessType = item.value
      }
    })
    return idBusinessType
  }

  getOnlineByID = async id => {
    this.setState({ isLoading: true })
    const res = await comprehensiveController().getOnlineID(id, '')
    // console.log('getOnlineByID', res)
    if (res) {
      let businessType = []
      for (var i = 0; i < res.online_business_type_group.length; i++) {
        const onlineBusinessType =
          res.online_business_type_group[i].online_business_type || []
        let newOnlineBusinessType = []
        for (var l = 0; l < onlineBusinessType.length; l++) {
          newOnlineBusinessType.push({
            id: onlineBusinessType[l].id,
            group_id: onlineBusinessType[l].group_id,
            label: onlineBusinessType[l].business_type,
            value: this.getIdBusinessType(onlineBusinessType[l].business_type),
          })
        }
        businessType.push({
          id: res.online_business_type_group[i].id,
          online_template_id:
            res.online_business_type_group[i].online_template_id,
          valueCategoryCompany: newOnlineBusinessType,
        })
      }
      if (this._isMounted) {
        await this.setState({
          onlineByID: res,
          name: res.name,
          description: res.description,
          businessType: businessType,
          isLoading: false,
          file: res.online_template_file || [],
        })
        this.setOnlineByID()
      }
    }
    this.setState({ isLoading: false })
  }

  setOnlineByID() {
    const { onlineByID } = this.state
    if (onlineByID) {
      let sections = []
      for (
        var sIndex = 0;
        sIndex < onlineByID.online_template_section.length;
        sIndex++
      ) {
        const onlineTemplateQuestionGroup =
          onlineByID.online_template_section[sIndex]
            .online_template_question_group || []
        let groups = []
        for (
          var gIndex = 0;
          gIndex < onlineTemplateQuestionGroup.length;
          gIndex++
        ) {
          const onlineTemplateQuestion =
            onlineTemplateQuestionGroup[gIndex].online_template_question || []
          let questions = []
          for (
            var qIndex = 0;
            qIndex < onlineTemplateQuestion.length;
            qIndex++
          ) {
            questions.push({
              id: onlineTemplateQuestion[qIndex].id,
              template_question_group_id:
                onlineTemplateQuestion[qIndex].template_question_group_id,
              position: onlineTemplateQuestion[qIndex].position,
              questionDesc: onlineTemplateQuestion[qIndex].question,
              requirement: onlineTemplateQuestion[qIndex].requirement,
              requirementAttachFile: onlineTemplateQuestion[qIndex].required,
              requirementComment:
                onlineTemplateQuestion[qIndex].required_to_add_comment,
              requirementCommentAndAttachFile:
                onlineTemplateQuestion[qIndex].required_to_add_comment_or_file,
            })
          }
          groups.push({
            id: onlineTemplateQuestionGroup[gIndex].id,
            template_section_id:
              onlineTemplateQuestionGroup[gIndex].template_section_id,
            position: onlineTemplateQuestionGroup[gIndex].position,
            nameGroup: onlineTemplateQuestionGroup[gIndex].name,
            descriptionGroup: onlineTemplateQuestionGroup[gIndex].description,
            required: onlineTemplateQuestionGroup[gIndex].is_required,
            questions: questions,
          })
        }
        sections.push({
          id: onlineByID.online_template_section[sIndex].id,
          online_template_id:
            onlineByID.online_template_section[sIndex].online_template_id,
          position: onlineByID.online_template_section[sIndex].position,
          nameSection: onlineByID.online_template_section[sIndex].name,
          descriptionSection:
            onlineByID.online_template_section[sIndex].description,
          weight: onlineByID.online_template_section[sIndex].weight,
          group: groups,
          sectionShow: false,
        })
      }
      // console.log(sections)
      if (this._isMounted) {
        this.setState({
          sectionList: sections,
        })
        this.funcCheckShowSecsion(0)
      }
    }
  }

  handleUserInput = e => {
    const { name, value } = e.target
    this.setState({ [name]: value }, () => {
      this.validateField(name, value.trim())
      //console.log('value!!!!!!!!!!!!!!!', value.trim())
    })
    if (e.target.id === 'name' && this.state.isNameDuplicated) {
      this.setState({ isNameDuplicated: false })
    }
  }

  validateField = (fieldName, value) => {
    let nameValid = this.state.nameValid
    let descriptionValid = this.state.descriptionValid
    let roleValid = this.state.roleValid

    switch (fieldName) {
      case 'name':
        nameValid = value.length !== 0
        this.setState({ nameValid: nameValid })
        break
      case 'description':
        descriptionValid = value.length !== 0
        this.setState({ descriptionValid: descriptionValid })
        break
      // case 'role':
      //   this.state.optionsRoleValue === null
      //   this.setState({ roleValid: roleValid })
      //   break
      default:
        break
    }

    // this.setState({
    //   nameValid: nameValid,
    //   emailValid: emailValid,
    //   phoneValid: phoneValid,
    // })
  }

  onSave() {
    const { onlineByID } = this.state
    // let sameBusinessType = await this.checkBusinessType()
    // if (sameBusinessType) {
    //   toastFail('Please check business type.')
    // } else {
    //   let weightTotal = await this.checkWeight()
    //   if (weightTotal && !sameBusinessType) {
    if (onlineByID === '') {
      this.createOnlineTemplate()
    } else {
      this.updateOnlineTemplate()
    }
    //   } else {
    //     toastFail('Please specify the total weight of the score to be 100%.')
    //     this.setState({ weightValidate: true })
    //   }
    // }
  }

  createOnlineTemplate = async () => {
    const { name, description, file, businessType, sectionList } = this.state

    // this.setState({ isLoading: true, modal: '' })
    let onlineBusinessTypeGroup = []
    for (var i = 0; i < businessType.length; i++) {
      const valueCategoryCompany = businessType[i].valueCategoryCompany || []
      let onlineBusinessType = []
      for (var l = 0; l < valueCategoryCompany.length; l++) {
        if (valueCategoryCompany[l].label !== 'Select all') {
          onlineBusinessType.push({
            business_type: valueCategoryCompany[l].label,
          })
        }
      }
      onlineBusinessTypeGroup.push({
        online_business_type: onlineBusinessType,
      })
    }

    let onlineTemplateSection = []
    for (var sIndex = 0; sIndex < sectionList.length; sIndex++) {
      const group = sectionList[sIndex].group || []
      let onlineTemplateQuestionGroup = []
      for (var gIndex = 0; gIndex < group.length; gIndex++) {
        const questions = group[gIndex].questions || []
        let onlineTemplateQuestion = []
        for (var qIndex = 0; qIndex < questions.length; qIndex++) {
          onlineTemplateQuestion.push({
            question: questions[qIndex].questionDesc,
            requirement: questions[qIndex].requirement,
            required: questions[qIndex].requirementAttachFile,
            required_to_add_comment: questions[qIndex].requirementComment,
            required_to_add_comment_or_file:
              questions[qIndex].requirementCommentAndAttachFile,
            position: qIndex,
          })
        }

        onlineTemplateQuestionGroup.push({
          name: group[gIndex].nameGroup,
          description: group[gIndex].descriptionGroup,
          is_required: group[gIndex].required,
          online_template_question: onlineTemplateQuestion,
          position: gIndex,
        })
      }

      onlineTemplateSection.push({
        name: sectionList[sIndex].nameSection,
        description: sectionList[sIndex].descriptionSection,
        weight: parseFloat(sectionList[sIndex].weight),
        online_template_question_group: onlineTemplateQuestionGroup,
        position: sIndex,
      })
    }
    // console.log('data file', file)
    // let onlineTemplateFile = []
    // if (file !== '') {
    //   for (var fIndex = 0; fIndex < file.length; fIndex++) {
    //     if (file[fIndex].files) {
    //       let uploadFile = await this.uploadFile(file[fIndex])
    //       onlineTemplateFile.push(uploadFile)
    //     } else {
    //       onlineTemplateFile.push(file[fIndex])
    //     }
    //   }
    // }
    let data = {
      id: '',
      name: name,
      description: description,
      online_template_file: file || [],
      online_business_type_group: onlineBusinessTypeGroup,
      online_template_section: onlineTemplateSection,
    }
    // console.log('data', data)
    const res = await comprehensiveController().createOnline(data)
    // console.log(res)
    this.setState({ isLoading: false })
    if (res) {
      if (res === 'Update online template success') {
        toastActive('Add online template success')
        this.props.history.push(
          ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
          { from: 'online' }
        )
      } else {
        toastFail(res)
        if (res.toString().includes('Template name was duplicated')) {
          this.setState({ isNameDuplicated: true })
        }
      }
    } else {
      toastFail('Please check input value')
    }
  }

  updateOnlineTemplate = async () => {
    const {
      name,
      description,
      businessType,
      sectionList,
      onlineByID,
      file,
    } = this.state

    this.setState({ isLoading: true, modal: '' })
    let onlineBusinessTypeGroup = []
    for (var i = 0; i < businessType.length; i++) {
      const valueCategoryCompany = businessType[i].valueCategoryCompany || []
      let onlineBusinessType = []
      for (var l = 0; l < valueCategoryCompany.length; l++) {
        if (valueCategoryCompany[l].label !== 'Select all') {
          onlineBusinessType.push({
            // id: valueCategoryCompany[l].id || '',
            // group_id: valueCategoryCompany[l].group_id || '',
            business_type: valueCategoryCompany[l].label,
          })
        }
      }
      onlineBusinessTypeGroup.push({
        // id: businessType[i].id || '',
        online_template_id: onlineByID.id || '',
        online_business_type: onlineBusinessType,
      })
    }

    let onlineTemplateSection = []
    for (var sIndex = 0; sIndex < sectionList.length; sIndex++) {
      const group = sectionList[sIndex].group || []
      let onlineTemplateQuestionGroup = []
      for (var gIndex = 0; gIndex < group.length; gIndex++) {
        const questions = group[gIndex].questions || []
        let onlineTemplateQuestion = []
        for (var qIndex = 0; qIndex < questions.length; qIndex++) {
          onlineTemplateQuestion.push({
            id: questions[qIndex].id || '',
            template_question_group_id:
              questions[qIndex].template_question_group_id || '',
            question: questions[qIndex].questionDesc,
            requirement: questions[qIndex].requirement,
            required: questions[qIndex].requirementAttachFile,
            required_to_add_comment: questions[qIndex].requirementComment,
            required_to_add_comment_or_file:
              questions[qIndex].requirementCommentAndAttachFile,
            position: qIndex,
          })
        }

        onlineTemplateQuestionGroup.push({
          id: group[gIndex].id || '',
          template_section_id: group[gIndex].template_section_id || '',
          name: group[gIndex].nameGroup,
          description: group[gIndex].descriptionGroup,
          is_required: group[gIndex].required,
          online_template_question: onlineTemplateQuestion,
          position: gIndex,
        })
      }

      onlineTemplateSection.push({
        id: sectionList[sIndex].id || '',
        online_template_id: sectionList[sIndex].online_template_id || '',
        name: sectionList[sIndex].nameSection,
        description: sectionList[sIndex].descriptionSection,
        weight: parseFloat(sectionList[sIndex].weight),
        online_template_question_group: onlineTemplateQuestionGroup,
        position: sIndex,
      })
    }

    // let onlineTemplateFile = []
    // // console.log('update file', file)
    // if (file !== '') {
    //   for (var fIndex = 0; fIndex < file.length; fIndex++) {
    //     if (file[fIndex].files) {
    //       let uploadFile = await this.uploadFile(file[fIndex])
    //       onlineTemplateFile.push(uploadFile)
    //     } else {
    //       onlineTemplateFile.push(file[fIndex])
    //     }
    //   }
    // }

    let data = {
      id: onlineByID.id,
      name: name,
      description: description,
      online_template_file: file || [],
      online_business_type_group: onlineBusinessTypeGroup,
      online_template_section: onlineTemplateSection,
    }
    // console.log('update data', data)
    const res = await comprehensiveController().createOnline(data)
    // console.log(res)
    this.setState({ isLoading: false })
    if (res) {
      if (res === 'Update online template success') {
        toastActive('Update online template success')
        this.props.history.push(
          ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
          { from: 'online' }
        )
      } else {
        toastFail(res)
        if (res.toString().includes('Template name was duplicated')) {
          this.setState({ isNameDuplicated: true })
        }
      }
    } else {
      toastFail('Please check input value')
    }
  }

  uploadFile = async (data, cb) => {
    let response = ''
    let formData = new FormData()
    formData.append('name', data.name)
    formData.append('file', data.files)
    const res = await comprehensiveController().upLoadFileOnlineTemplate(
      formData
    )
    // console.log(res)
    if (res) {
      response = {
        id: res.id,
        name: res.name,
        is_deleted: false,
      }
      let dataFiles = Array.isArray(this.state.file) ? [...this.state.file] : []
      dataFiles.push(response)
      this.setState({ file: dataFiles }, cb)
      this.checkField()
    }
    // return response
  }

  renderBusinessType(item, index) {
    const {
      categoryCompany,
      isErrorCategoryCompany,
      businessType,
      sameBusinessType,
    } = this.state
    const handleChange = select => {
      // if (this._isMounted) {
      if (select) {
        let newBusinessType = [...businessType]
        newBusinessType[index].valueCategoryCompany = select
        this.setState({
          businessType: newBusinessType,
          sameBusinessType: [],
        })
        this.checkField()
      }
      // }
    }
    let isSame = false
    for (var i = 0; i < sameBusinessType.length; i++) {
      if (sameBusinessType[i] === index) {
        isSame = true
      }
    }
    // console.log(isSame)
    return (
      <Section key={'businessType' + index} className="form-group-outer">
        <Section className="form-group-inner-wrapper">
          <SelectBoxBusinessType
            options={categoryCompany}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option,
              MultiValue,
              ValueContainer,
              AnimatedComponents,
            }}
            allowSelectAll={false}
            notAllowDuplicate={true}
            onChange={handleChange}
            fieldValue={item.valueCategoryCompany}
            isErrCategory={isErrorCategoryCompany}
            isErrored={true}
            className={
              (item.valueCategoryCompany.length == 0 && this.state.isSubmit) ||
              isSame
                ? ' is-error'
                : ''
            }
          />
          <Button
            className="btn-link"
            isDisable={businessType.length > 1 ? false : true}
            onClick={() => {
              let newBusinessType = [...businessType]
              newBusinessType.splice(index, 1)
              this.setState({ businessType: newBusinessType })
              // this.checkField()
              setTimeout(() => {
                this.checkField()
              }, 500)
            }}
          >
            <Image
              className="delete-icon"
              src={ICONS['icon-trash.svg']}
              alt="delete"
            />
          </Button>
        </Section>
        <Section className="message">
          {item.valueCategoryCompany.length == 0 && this.state.isSubmit
            ? STRING.INVALID
            : ''}
          {isSame ? 'This business type has been used.' : ''}
        </Section>
      </Section>
    )
  }

  funcCheckShowSecsion(index) {
    const { sectionList } = this.state
    if (sectionList && sectionList.length > 0) {
      sectionList.forEach((item, i) => {
        if (index === i) {
          item.sectionShow = !item.sectionShow
          this.setState({ sectionList })
        } else {
          item.sectionShow = false
          this.setState({ sectionList })
        }
      })
    }
  }

  checkBusinessType = async () => {
    const { businessType } = this.state
    let isSame = false
    let sameList = []
    for (var i = 0; i < businessType.length; i++) {
      const valueCategoryCompany = businessType[i].valueCategoryCompany || []
      let sameCategory = businessType.filter(
        (item, index) =>
          item.valueCategoryCompany.length === valueCategoryCompany.length &&
          index !== i
      )
      if (sameCategory.length > 0) {
        for (var l = 0; l < sameCategory.length; l++) {
          const sameValueCategoryCompany =
            sameCategory[l].valueCategoryCompany || []
          let sameCount = 0
          for (
            var sIndex = 0;
            sIndex < sameValueCategoryCompany.length;
            sIndex++
          ) {
            for (
              var valueIndex = 0;
              valueIndex < valueCategoryCompany.length;
              valueIndex++
            ) {
              if (
                sameValueCategoryCompany[sIndex].value ===
                valueCategoryCompany[valueIndex].value
              ) {
                sameCount = sameCount + 1
              }
            }
          }
          if (sameCount === sameValueCategoryCompany.length) {
            isSame = true
            sameList.push(i)
          }
        }
      }
      // console.log(businessType[i])
      let groupId = businessType[i].id || ''
      let checkOnline = []
      valueCategoryCompany.map(item => {
        if (item.label !== 'Select all') {
          checkOnline.push({ business_type: item.label })
        }
      })
      let checkSameOnline = await this.checkBusinessTypeOnline(
        checkOnline,
        groupId
      )
      if (checkSameOnline === true) {
        isSame = true
        sameList.push(i)
      }
    }
    this.setState({ sameBusinessType: sameList })
    return isSame
  }

  checkBusinessTypeOnline = async (data, groupId) => {
    let isSame = false
    const res = await comprehensiveController().checkBusinessType(data, groupId)
    // console.log(res)
    if (res && res.data && res.data.status === 'success') {
      if (!res.data.result) {
        isSame = true
      }
    } else {
      isSame = false
    }
    return isSame
  }

  checkField() {
    const { name, description, businessType, sectionList } = this.state
    let isDiseble = false
    if (name === '') {
      isDiseble = true
    }
    for (var i = 0; i < businessType.length; i++) {
      const valueCategoryCompany = businessType[i].valueCategoryCompany || []
      if (valueCategoryCompany.length === 0) {
        isDiseble = true
      }
    }
    if (sectionList.length === 0) {
      isDiseble = true
    } else {
      for (var sIndex = 0; sIndex < sectionList.length; sIndex++) {
        const group = sectionList[sIndex].group || []
        if (group.length === 0 || sectionList[sIndex].nameSection === '') {
          isDiseble = true
        } else {
          for (var gIndex = 0; gIndex < group.length; gIndex++) {
            const questions = group[gIndex].questions || []
            if (questions.length === 0 || group[gIndex].nameGroup === '') {
              isDiseble = true
            } else {
              for (var qIndex = 0; qIndex < questions.length; qIndex++) {
                if (questions[qIndex].questionDesc === '') {
                  isDiseble = true
                }
              }
            }
          }
        }
      }
    }
    this.setState({ disebleSave: isDiseble })
  }

  checkWeight() {
    const { sectionList } = this.state
    let totalWeight = 0
    for (var sIndex = 0; sIndex < sectionList.length; sIndex++) {
      totalWeight = totalWeight + parseFloat(sectionList[sIndex].weight)
    }
    // console.log(totalWeight)
    if (totalWeight == 100) {
      return true
    } else {
      return false
    }
  }

  renderSectionList(item, index) {
    return (
      <Section
        key={'section' + index}
        mb={'1rem'}
        px={'24px'}
        pt={'15px'}
        pb={'30px'}
        className="card"
      >
        <Section className="flex-column">
          <AccordionOnlineList
            expanded={item.sectionShow}
            onChange={() => {
              this.funcCheckShowSecsion(index)
            }}
          >
            <AccordionOnlineList.Head>
              <Section p={'1rem'} className="flex-column card-section">
                <Section
                  className={
                    'form-group row' +
                    (item.nameSection == '' && this.state.isSubmit
                      ? ' is-error'
                      : '')
                  }
                >
                  <label className="col-3">Section Name</label>

                  <Section className="form-group-outer col-8">
                    <Section className="form-group-inner-wrapper">
                      <Input
                        id="nameSection"
                        type="text"
                        name="nameSection"
                        placeholder="Section Name"
                        value={item.nameSection}
                        onChange={e => {
                          let newSection = [...this.state.sectionList]
                          item.nameSection = e.target.value
                          newSection[index] = item
                          this.setState({ sectionList: newSection })
                          // this.checkField()
                        }}
                        onBlur={() => {
                          this.checkField()
                        }}
                      />
                    </Section>

                    <Section className="message">
                      {item.nameSection == '' && this.state.isSubmit
                        ? STRING.INVALID
                        : ''}
                    </Section>
                  </Section>

                  <Section className="col-1">
                    <Button
                      className="btn-link"
                      onClick={() => {
                        this.setState({
                          modalDelete: 'section' + index,
                          sectionIndex: index,
                        })
                      }}
                    >
                      <Image
                        className="delete-icon"
                        src={ICONS['icon-trash.svg']}
                        alt="delete"
                      />
                    </Button>
                  </Section>
                </Section>
                <Section className="form-group row">
                  <label className="col-3">
                    Section Description <br /> (Optional)
                  </label>

                  <Section className="form-group-outer col-8">
                    <Section className="form-group-inner-wrapper">
                      <InputTextarea
                        id="descriptionSection"
                        name="descriptionSection"
                        placeholder="Section Description"
                        value={item.descriptionSection}
                        onChange={e => {
                          let newSection = [...this.state.sectionList]
                          item.descriptionSection = e.target.value
                          newSection[index] = item
                          this.setState({ sectionList: newSection })
                        }}
                        onBlur={() => {
                          this.checkField()
                        }}
                      />
                    </Section>
                    <Section className="message"></Section>
                  </Section>
                  <Section className="col-1"></Section>
                </Section>
                <Section
                  className={
                    'form-group row ' +
                    ((item.weight == '' && this.state.isSubmit) ||
                    this.state.weightValidate
                      ? 'is-error'
                      : '')
                  }
                >
                  <label className="col-3">Weight (%)</label>
                  <Section className="form-group-outer col-4">
                    <Section className="form-group-inner-wrapper">
                      <NumberFormat
                        id="weight"
                        name="weight"
                        min={0}
                        max={100}
                        decimalScale={0}
                        fixedDecimalScale={true}
                        customInput={Input}
                        placeholder="Weight (%)"
                        value={item.weight}
                        onValueChange={e => {
                          console.log({ e })
                          if (
                            parseInt(e.value) < 0 ||
                            parseInt(e.value) > 100
                          ) {
                            toastFail('Please insert weight 0 to 100.')
                          } else {
                            let newSection = [...this.state.sectionList]
                            item.weight = e.value
                            newSection[index] = item
                            this.setState({
                              sectionList: newSection,
                              weightValidate: false,
                            })
                            // this.checkField()
                          }
                        }}
                        onBlur={() => {
                          this.checkField()
                        }}
                      />
                    </Section>

                    <Section className="message">
                      {item.weight == '' && this.state.isSubmit
                        ? STRING.INVALID
                        : ''}
                      {this.state.weightValidate
                        ? 'Please specify the total weight of the score to be 100%.'
                        : ''}
                    </Section>
                  </Section>
                  <Section className="col-1"></Section>
                </Section>
              </Section>
            </AccordionOnlineList.Head>
            <AccordionOnlineList.Body>
              <Section className="flex-column">
                <Section className="flex-column">
                  {item.group.map((gItem, gIndex) =>
                    this.renderGroup(gItem, gIndex, index)
                  )}
                </Section>
                <Section className="justify-content-end">
                  <Button
                    isDisable={item.nameSection != '' ? false : true}
                    className="theme-dodger-blue btn-width-auto btn-icon"
                    onClick={() => {
                      let newSectionList = [...this.state.sectionList]
                      let newGroup = [...this.state.sectionList[index].group]
                      newGroup.push({
                        nameGroup: '',
                        descriptionGroup: '',
                        required: true,
                        questions: [],
                      })
                      newSectionList[index].group = newGroup
                      this.setState({
                        sectionList: newSectionList,
                        isSubmit: false,
                      })
                      this.checkField()
                    }}
                  >
                    <Image src={ICONS['icon-add-group-2.svg']} alt="add icon" />
                    Add Group
                  </Button>
                </Section>
              </Section>
            </AccordionOnlineList.Body>
          </AccordionOnlineList>
        </Section>

        <Modal
          id="deleteSection"
          className="theme-blue"
          classNameContainer="widthModal"
          isOpen={this.state.modalDelete == 'section' + index}
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete section ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({ modalDelete: '', sectionIndex: '' })
              }
              className="theme-border-gray"
            >
              Cancel
            </Button>
            <Button
              className="theme-green"
              onClick={async () => {
                let newSection = [...this.state.sectionList]
                newSection.splice(this.state.sectionIndex, 1)
                // console.log('newSection ' + this.state.sectionIndex, newSection)
                await this.setState({
                  sectionList: newSection,
                  modalDelete: '',
                  sectionIndex: '',
                })
                toastActive('Delete Section successfully')
                this.checkField()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Section>
    )
  }

  renderGroup(item, index, sectionIndex) {
    return (
      <Section
        key={'group' + sectionIndex + index}
        className="flex-column card-group"
        mb={'10px'}
      >
        <Section
          className={
            'form-group row ' +
            (item.nameGroup == '' && this.state.isSubmit ? 'is-error' : '')
          }
        >
          <label className="col-3">
            {sectionIndex + 1 + '.' + (index + 1)} Group Name
          </label>

          <Section className="form-group-outer col-8">
            <Section className="form-group-inner-wrapper">
              <Input
                id="nameSection"
                type="text"
                name="nameSection"
                placeholder="Group Name"
                value={item.nameGroup}
                onChange={e => {
                  let newSection = [...this.state.sectionList]
                  item.nameGroup = e.target.value
                  newSection[sectionIndex].group[index] = item
                  this.setState({ sectionList: newSection })
                  // this.checkField()
                }}
                onBlur={() => {
                  this.checkField()
                }}
              />
            </Section>

            <Section className="message">
              {item.nameGroup == '' && this.state.isSubmit
                ? STRING.INVALID
                : ''}
            </Section>
          </Section>

          <Section className="col-1">
            <Button
              className="btn-link"
              onClick={() => {
                this.setState({
                  modalDelete: 'group' + sectionIndex + index,
                  sectionIndex: sectionIndex,
                  groupIndex: index,
                })
              }}
            >
              <Image
                className="delete-icon"
                src={ICONS['icon-trash.svg']}
                alt="delete"
              />
            </Button>
          </Section>
        </Section>
        <Section className="form-group row">
          <label className="col-3">
            Group Description <br /> (Optional)
          </label>

          <Section className="form-group-outer col-8">
            <Section className="form-group-inner-wrapper">
              <InputTextarea
                id="descriptionSection"
                name="descriptionSection"
                placeholder="Group Description"
                value={item.descriptionGroup}
                onChange={e => {
                  let newSection = [...this.state.sectionList]
                  item.descriptionGroup = e.target.value
                  newSection[sectionIndex].group[index] = item
                  this.setState({ sectionList: newSection })
                }}
                onBlur={() => {
                  this.checkField()
                }}
              />
            </Section>
          </Section>

          <Section className="col-1"></Section>
        </Section>
        <Section className="form-group row">
          <label className="col-3"></label>

          <Section className="form-group-outer col-8">
            <Section className="form-group-inner-wrapper justify-content-end">
              <Switcher
                onChange={e => {
                  let newSection = [...this.state.sectionList]
                  item.required = e
                  newSection[sectionIndex].group[index] = item
                  this.setState({ sectionList: newSection })
                  this.checkField()
                }}
                checked={item.required}
              />
              <label>Required</label>
            </Section>
          </Section>

          <Section className="col-1"></Section>
        </Section>

        <hr className="blue" />

        {/* Add Question */}
        {item.questions.map((qItem, qIndex) =>
          this.renderQuestions(qItem, qIndex, sectionIndex, index)
        )}
        <Section pr={'1rem'} className="justify-content-end">
          <Button
            isDisable={item.nameGroup != '' ? false : true}
            className="theme-light-blue btn-width-auto btn-icon"
            onClick={() => {
              let newSectionList = [...this.state.sectionList]
              let newGroup = [...this.state.sectionList[sectionIndex].group]
              let newQuestion = [
                ...this.state.sectionList[sectionIndex].group[index].questions,
              ]
              newQuestion.push({
                questionDesc: '',
                requirement: '',
                requirementAttachFile: false,
                requirementComment: false,
                requirementCommentAndAttachFile: false,
              })
              newGroup[index].questions = newQuestion
              newSectionList[sectionIndex].group = newGroup
              this.setState({
                sectionList: newSectionList,
                isSubmit: false,
                disebleSave: true,
              })
              this.checkField()
            }}
          >
            <Image src={ICONS['icon-add-question.svg']} alt="add icon" />
            Add Question
          </Button>
        </Section>

        <Modal
          id="deleteGroup"
          className="theme-blue"
          classNameContainer="widthModal"
          isOpen={this.state.modalDelete == 'group' + sectionIndex + index}
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete group ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({
                  modalDelete: '',
                  sectionIndex: '',
                  groupIndex: '',
                })
              }
              className="theme-border-gray"
            >
              Cancel
            </Button>
            <Button
              className="theme-green"
              onClick={() => {
                let newSection = [...this.state.sectionList]
                let newGroup = [
                  ...this.state.sectionList[this.state.sectionIndex].group,
                ]
                newGroup.splice(this.state.groupIndex, 1)
                newSection[this.state.sectionIndex].group = newGroup
                this.setState({
                  sectionList: newSection,
                  modalDelete: '',
                  sectionIndex: '',
                  groupIndex: '',
                })
                toastActive('Delete Group successfully')
                this.checkField()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Section>
    )
  }

  renderQuestions(item, index, sectionIndex, groupIndex) {
    return (
      <Section
        key={'question' + sectionIndex + groupIndex + index}
        mt={'1rem'}
        mb={'1rem'}
        className="flex-column"
      >
        <Section
          className={
            'form-group row ' +
            (item.questionDesc == '' && this.state.isSubmit ? 'is-error' : '')
          }
        >
          <label className="col-3">
            {sectionIndex + 1 + '.' + (groupIndex + 1) + '.' + (index + 1)}{' '}
            Question
          </label>

          <Section className="form-group-outer col-8">
            <Section className="form-group-inner-wrapper">
              <InputTextarea
                id="descriptionSection"
                name="descriptionSection"
                placeholder="Question"
                value={item.questionDesc}
                onChange={e => {
                  let newSection = [...this.state.sectionList]
                  item.questionDesc = e.target.value
                  newSection[sectionIndex].group[groupIndex].questions[
                    index
                  ] = item
                  this.setState({ sectionList: newSection })
                  this.checkField()
                }}
                // onBlur={() => {
                //   this.checkField()
                // }}
              />
            </Section>

            <Section className="message">
              {item.questionDesc == '' && this.state.isSubmit
                ? STRING.INVALID
                : ''}
            </Section>
          </Section>

          <Section className="col-1">
            <Button
              className="btn-link"
              onClick={() => {
                this.setState({
                  modalDelete: 'question' + groupIndex + sectionIndex + index,
                  sectionIndex: sectionIndex,
                  groupIndex: groupIndex,
                  questionIndex: index,
                })
              }}
            >
              <Image
                className="delete-icon"
                src={ICONS['icon-trash.svg']}
                alt="delete"
              />
            </Button>
          </Section>
        </Section>
        <Section className="form-group row">
          <label className="col-3">
            Requirement
            <br /> (Optional)
          </label>

          <Section className="form-group-outer col-8">
            <Section className="form-group-inner-wrapper">
              <InputTextarea
                id="descriptionSection"
                name="descriptionSection"
                placeholder="Requirement"
                value={item.requirement}
                onChange={e => {
                  let newSection = [...this.state.sectionList]
                  item.requirement = e.target.value
                  newSection[sectionIndex].group[groupIndex].questions[
                    index
                  ] = item
                  this.setState({ sectionList: newSection })
                }}
                onBlur={() => {
                  this.checkField()
                }}
              />
            </Section>

            <Section className="message"></Section>
          </Section>

          <Section className="col-1"></Section>
        </Section>
        <Section mb={'1rem'} pl={'2rem'} className="form-group row">
          <label className="col-3"></label>

          <Section className="form-group-outer col-8">
            <Section className="form-group-inner-wrapper">
              <Section className="checkbox-group">
                <Checkbox
                  disabled={item.requirementCommentAndAttachFile}
                  checked={item.requirementAttachFile}
                  id={
                    'requirementAttachFile' +
                    sectionIndex +
                    '.' +
                    groupIndex +
                    '.' +
                    index
                  }
                  onChange={e => {
                    let newSection = [...this.state.sectionList]
                    item.requirementAttachFile = e.target.checked
                    newSection[sectionIndex].group[groupIndex].questions[
                      index
                    ] = item
                    this.setState({ sectionList: newSection })
                    this.checkField()
                  }}
                >
                  Required to attach file.
                </Checkbox>
                <Checkbox
                  disabled={item.requirementCommentAndAttachFile}
                  checked={item.requirementComment}
                  id={
                    'requirementComment' +
                    sectionIndex +
                    '.' +
                    groupIndex +
                    '.' +
                    index
                  }
                  onChange={e => {
                    let newSection = [...this.state.sectionList]
                    item.requirementComment = e.target.checked
                    newSection[sectionIndex].group[groupIndex].questions[
                      index
                    ] = item
                    this.setState({ sectionList: newSection })
                    this.checkField()
                  }}
                >
                  Required to add comment.
                </Checkbox>
                <Checkbox
                  disabled={
                    item.requirementAttachFile && item.requirementComment
                  }
                  checked={item.requirementCommentAndAttachFile}
                  id={
                    'requirementCommentAndAttachFile' +
                    sectionIndex +
                    '.' +
                    groupIndex +
                    '.' +
                    index
                  }
                  onChange={e => {
                    let newSection = [...this.state.sectionList]
                    item.requirementCommentAndAttachFile = e.target.checked
                    item.requirementAttachFile = false
                    item.requirementComment = false
                    newSection[sectionIndex].group[groupIndex].questions[
                      index
                    ] = item
                    this.setState({ sectionList: newSection })
                    this.checkField()
                  }}
                >
                  Required to add comment or attach file.
                </Checkbox>
              </Section>
            </Section>
          </Section>

          <Section className="col-1"></Section>
        </Section>

        <hr />

        <Modal
          id="deleteQuestion"
          className="theme-blue"
          classNameContainer="widthModal"
          isOpen={
            this.state.modalDelete ==
            'question' + groupIndex + sectionIndex + index
          }
          modalWidth="575px"
        >
          <Modal.Header>Delete</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to delete question ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({
                  modalDelete: '',
                  sectionIndex: '',
                  groupIndex: '',
                  questionIndex: '',
                })
              }
              className="theme-border-gray"
            >
              Cancel
            </Button>
            <Button
              className="theme-green"
              onClick={() => {
                let newSection = [...this.state.sectionList]
                let newGroup = [
                  ...this.state.sectionList[this.state.sectionIndex].group,
                ]
                let newQuestion = [
                  ...this.state.sectionList[this.state.sectionIndex].group[
                    this.state.groupIndex
                  ].questions,
                ]
                newQuestion.splice(this.state.questionIndex, 1)
                newGroup[this.state.groupIndex].questions = newQuestion
                newSection[this.state.sectionIndex].group = newGroup
                this.setState({
                  sectionList: newSection,
                  modalDelete: '',
                  sectionIndex: '',
                  groupIndex: '',
                  questionIndex: '',
                })
                toastActive('Delete question successfully')
                this.checkField()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Section>
    )
  }

  downloadFileAnswer = async file => {
    // console.log(file)
    const { loadingDownloadFile } = this.state
    let loadingDownload = loadingDownloadFile
    if (file.id !== '') {
      try {
        const dataFile = await comprehensiveController().downloadTemplateFile(
          file.id
        )
        const { data } = dataFile
        FileDownload(data, file.name)
        let index = loadingDownload.findIndex(x => x.id === file.id)
        loadingDownload.splice(index, 1)
        this.setState({
          loadingDownloadFile: loadingDownload,
        })
      } catch (error) {
        console.log(error)
      }
    } else {
      FileDownload(file.files, file.name)
    }
  }

  renderDownloadFile = file => {
    const { loadingDownloadFile } = this.state
    return (
      loadingDownloadFile &&
      loadingDownloadFile.map((value, index) => {
        if (value.id === file.id) {
          return (
            <Loaders
              load={true}
              key={index}
              style={
                {
                  // marginLeft: '-35px',
                  // position: 'relative',
                  // right: '-75px',
                }
              }
            />
          )
        }
      })
    )
  }

  handlersDeleteFile = e => {
    const { file } = this.state
    if (file != '') {
      file.length > 0 &&
        file.map(val => {
          if (val.id === e.id) {
            val.is_deleted = true
          }
        })
    }
  }

  render() {
    return (
      <OnlineTemplateManegementStyle>
        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                src={ICONS['icon-comprehensive- assessment.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section className="title">
                {STRING.COMPREHENSIVE_ASSESSMENT_MANAGEMENT}
              </Section>
              {/* <Breadcrumbs props={this.props} /> */}
              <Section
                id="page_breadcrumb_buyer_management"
                className="breadcrumbs"
              >
                <Button
                  className="breadcrumb"
                  onClick={() => this.props.history.push(ROUTE_PATH.HOME.LINK)}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button
                  className="breadcrumb"
                  onClick={() =>
                    this.props.history.push(
                      ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
                      { from: 'online' }
                    )
                  }
                >
                  <span>{STRING.COMPREHENSIVE_ASSESSMENT_MANAGEMENT}</span>
                </Button>
                <Button className="breadcrumb current">
                  <span>{this.state.pageTitle}</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* Add Group Business Type */}
        <Section
          mb={'1rem'}
          px={'24px'}
          pt={'15px'}
          pb={'30px'}
          className="card card-template"
        >
          <Section className="flex-column">
            <Section
              className={
                'form-group row' +
                ((this.state.name == '' || this.state.isNameDuplicated) &&
                this.state.isSubmit
                  ? ' is-error'
                  : '')
              }
            >
              <label className="col-2">Template Name</label>

              <Section className="form-group-outer col-10">
                <Section className="form-group-inner-wrapper">
                  <Input
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Template Name"
                    value={this.state.name}
                    onChange={this.handleUserInput}
                    onBlur={() => {
                      this.checkField()
                    }}
                  />
                </Section>

                <Section className="message">
                  {this.state.name == '' && this.state.isSubmit
                    ? STRING.INVALID
                    : ''}
                  {this.state.isNameDuplicated && this.state.isSubmit
                    ? 'Template name was duplicated'
                    : ''}
                </Section>
              </Section>
            </Section>
            <Section className="form-group row">
              <label className="col-2">
                Form Description <br /> (Optional)
              </label>

              <Section className="form-group-outer col-10">
                <Section className="form-group-inner-wrapper">
                  <InputTextarea
                    id="description"
                    name="description"
                    placeholder="Form Description"
                    value={this.state.description}
                    onChange={this.handleUserInput}
                    onBlur={() => {
                      this.checkField()
                    }}
                  />
                </Section>

                <Section className="message">
                  {!this.state.formValid && !this.state.descriptionValid
                    ? STRING.INVALID
                    : ''}
                </Section>
              </Section>
            </Section>
            {/* Add Group Business Type */}
            <Section
              className={
                'form-group row ' +
                (this.state.businessType.length == 1 &&
                  this.state.businessType[0].valueCategoryCompany.length == 0 &&
                  this.state.isSubmit &&
                  ' is-error')
              }
            >
              <label className="col-2">Business Type</label>
              {/* {this.renderOptionsCategory()} */}
              <div className="col-10">
                {this.state.businessType.map((item, index) =>
                  this.renderBusinessType(item, index)
                )}
              </div>
            </Section>

            <Section className="justify-content-end bottom-template-wrapper">
              <div className="attached-wrapper">
                <div className="attached-list">
                  {this.state.file !== '' &&
                    this.state.file.map(
                      (item, fIndex) =>
                        !item.is_deleted && (
                          <>
                            <div className="file-link" key={'file' + fIndex}>
                              {this.renderDownloadFile(item)}
                              <div className="file-link-wrapper">
                                <a
                                  onClick={() => {
                                    this.state.loadingDownloadFile.push({
                                      id: item.id,
                                    })
                                    this.setState({
                                      loadingDownloadFile: this.state
                                        .loadingDownloadFile,
                                    })
                                    this.downloadFileAnswer(item)
                                  }}
                                >
                                  {item.name || ''}
                                </a>
                                <Button
                                  className="link"
                                  onClick={() => {
                                    item.is_deleted = true
                                    this.setState({ file: this.state.file })
                                    this.checkField()
                                  }}
                                >
                                  <Image
                                    className="delete-circle-icon delete_company_profile"
                                    src={ICONS['icon-delete-circle-red.svg']}
                                    alt="delete circle"
                                  />
                                </Button>
                              </div>
                            </div>
                          </>
                        )
                    )}
                </div>
                {/* {this.state.file != '' && (
                  <AttachedFile
                    classNameFile="attached-list"
                    isUpload={false}
                    fileList={this.state.file}
                    onDowload={e => {
                      this.state.loadingDownloadFile.push({
                        id: e.id,
                      })
                      this.setState({
                        loadingDownloadFile: this.state.loadingDownloadFile,
                      })
                      this.downloadFileAnswer(e)
                    }}
                    hasRemove={true}
                    onRemove={e => {
                      this.handlersDeleteFile(e)
                    }}
                  />
                )} */}
              </div>
              <div className="attached-wrapper">
                <AttachedFile
                  maxFileSizeMb={50}
                  onSelect={(file, e, cb) => {
                    if (file != null) {
                      let params = {
                        name: file.name,
                        files: file,
                      }
                      this.uploadFile(params, cb)
                    }
                  }}
                  isShow={false}
                />
              </div>

              <Button
                className="theme-dodger-blue btn-width-auto btn-icon"
                onClick={() => {
                  let newBusinessType = [...this.state.businessType]
                  newBusinessType.push({ valueCategoryCompany: [] })
                  this.setState({
                    businessType: newBusinessType,
                    disebleSave: true,
                  })
                  // this.checkField()
                }}
              >
                <Image src={ICONS['icon-add-group.svg']} alt="add icon" />
                Add Group Business Type
              </Button>
            </Section>
          </Section>
        </Section>

        {/* Add Section */}
        {this.state.sectionList.map((item, index) =>
          this.renderSectionList(item, index)
        )}

        <Section className="form-actions">
          <Button
            id="close_modal_history_id"
            className="theme-border-gray"
            onClick={() => {
              this.props.history.push(
                ROUTE_PATH.COMPREHENSIVE_ASSESSMENT_MANAGEMENT.LINK,
                { from: 'online' }
              )
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={this.state.disebleSave}
            className="theme-green"
            onClick={async () => {
              let sameBusinessType = await this.checkBusinessType()
              if (sameBusinessType) {
                toastFail('Please check business type.')
              } else {
                let weightTotal = await this.checkWeight()
                if (weightTotal && !sameBusinessType) {
                  this.setState({ modal: 'confirm' })
                } else {
                  toastFail(
                    'Please specify the total weight of the score to be 100%.'
                  )
                  this.setState({ weightValidate: true })
                }
              }
            }}
          >
            Save
          </Button>
          <Button
            className="theme-blue btn-width-auto btn-icon"
            disabled={
              this.state.name == '' ||
              this.state.businessType[0].valueCategoryCompany.length == 0
            }
            onClick={async () => {
              let sameBusinessType = await this.checkBusinessType()
              if (sameBusinessType) {
                toastFail('Please check business type.')
              } else {
                this.funcCheckShowSecsion(-1)
                let newSectionList = [...this.state.sectionList]
                newSectionList.push({
                  nameSection: '',
                  descriptionSection: '',
                  weight: '',
                  group: [],
                  sectionShow: true,
                })
                this.setState({
                  sectionList: newSectionList,
                  isSubmit: false,
                  weightValidate: false,
                })
                this.checkField()
              }
            }}
          >
            <Image
              src={ICONS['icon-add-section.svg']}
              alt="add icon"
              mr={'1rem'}
            />
            Add Section
          </Button>
        </Section>

        <Modal
          id="confirm"
          className="theme-blue"
          classNameContainer="widthModal"
          isOpen={this.state.modal == 'confirm'}
          modalWidth="575px"
        >
          <Modal.Header>Save</Modal.Header>
          <Modal.Body>
            <p className="default text-center">
              Are you sure to save template ?
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => this.setState({ modal: '', sectionIndex: '' })}
              className="theme-border-gray"
            >
              Cancel
            </Button>
            <Button
              className="theme-green"
              onClick={() => {
                this.setState({ isSubmit: true })
                this.onSave()
              }}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        <Loading loading={this.state.isLoading} />
      </OnlineTemplateManegementStyle>
    )
  }
}
